module.exports = __webpack_public_path__ + "static/media/fallout.495f39b0.jpg";